<template>
	<div class="category">
		<form class="category__add" @submit.prevent="addCategory">
			<table class="simple-table">
				<thead>
					<tr>
						<th class="category__name">브랜드 카테고리명</th>
						<th class="category__order">정렬순서</th>
						<th class="category__display">전시여부</th>
						<th class="category__image">이미지</th>
						<th class="category__button">등록하기</th>
					</tr>
				</thead>
				<tbody>
					<tr>
						<td class="category__name">
							<input
								type="text"
								class="input-text"
								placeholder="브랜드 카테고리명을 입력하세요"
								v-model="brandCategoryText"
							/>
						</td>
						<td class="category__order">
							<input
								type="number"
								class="input-text"
								placeholder="정렬순서를 입력하세요"
								v-model="sortKey"
							/>
						</td>
						<td class="category__display">
							<RadioList
								class="radio-box__input"
								:radioList="radioList"
								v-model="display"
								keyName="id"
								valueName="value"
							/>
						</td>
						<td class="category__image">
							<input
								type="file"
								placeholder="브랜드 카테고리 이미지"
								ref="brandCategoryImage"
								@change="handleFileUpload($event)"
							/>
						</td>
						<td class="category__button">
							<button class="btn blue">등록</button>
						</td>
					</tr>
				</tbody>
			</table>
		</form>
	</div>
</template>
<script>
	import RadioList from '../RadioList.vue';
	import { imageUpload } from '@/util';

	export default {
		components: {
			RadioList,
		},
		data() {
			return {
				display: true,
				radioList: [
					{ id: true, value: 'Y' },
					{ id: false, value: 'N' },
				],
				fileDir: '',
				fileSaveName: '',
				sortKey: '',
				brandCategoryText: '',
			};
		},
		methods: {
			readFile(file) {
				return new Promise(resolve => {
					const reader = new FileReader();
					reader.onload = e => {
						const file = new Image();
						file.src = e.target.result;

						file.onload = () => {
							resolve(e);
						};
					};
					reader.readAsDataURL(file);
				});
			},
			addImg(urlList, files) {
				const list = urlList.map((url, idx) => {
					const srcObj = {
						src: url,
						fileObject: files[idx],
						extension: files[idx].type.split('/').pop(),
					};
					return srcObj;
				});
				this.uploadImage(list[0]);
			},
			async uploadImage(imageObj) {
				const { extension, fileObject } = imageObj;

				try {
					const res = await imageUpload(
						extension,
						'award-module',
						fileObject
					);
					const filePath = `/${res.config.data.get('key')}`;
					const fileSaveName = filePath.split('/').pop();
					const imgPath = filePath.replace(/\/[^/]+\/?$/, '');

					this.fileDir = imgPath;
					this.fileSaveName = fileSaveName;
				} catch (err) {
					console.error(err);
				}
			},

			async handleFileUpload(event) {
				const files = [...event.target.files];
				const readFileList = await Promise.all(
					files.map(file => this.readFile(file))
				);
				const urlList = readFileList.map(({ target }) => target.result);
				this.addImg(urlList, files);
			},

			async addCategory() {
				const params = {
					brandCategoryText: this.brandCategoryText,
					isDisplay: this.display,
					sortKey: this.sortKey,
					fileDir: this.fileDir,
					fileSaveName: this.fileSaveName,
				};
				try {
					if (!this.brandCategoryText) {
						alert('브랜드 카테고리명을 입력해주세요.');
						return;
					}
					if (!this.sortKey || this.sortKey === 0) {
						alert('정렬순서를 입력해주세요.');
						return;
					}
					await this.$axiosAdmin2.post(
						'/api/brands/category',
						params
					);
					alert('등록되었습니다.');
					this.$emit('getList');
					this.init();
				} catch (error) {
					console.error(error);
					alert(
						'등록에 실패했습니다. 지속적인 문제 발생시 개발팀에 문의주세요.'
					);
				}
			},
			init() {
				this.display = true;
				this.sortKey = '';
				this.brandCategoryText = '';
				this.fileDir = '';
				this.fileSaveName = '';
			},
		},
	};
</script>
<style lang="scss" scoped>
	.category {
		margin-top: 30px;
		padding: 0 50px;
		.simple-table {
			th {
				background: linear-gradient(to top, #d3e1f1, #f4f7fa, #f4f7fa);
				border: solid 1px #d5dde6;
				text-align: center;
				padding: 0;
			}
			td {
				text-align: center;
			}
		}
		.category__name {
			width: 30%;
		}
		.category__order {
			width: 20%;
		}
		.category__display {
			width: 10%;
		}
		.category__image {
			width: 20%;
		}
		.category__button {
			width: 10%;
		}
	}
</style>
